import * as cloudinary from '@micromart/utils/lib/cloudinary'
import Box from '@mui/material/Box'
import { Image as ImageIcon } from '@phosphor-icons/react/dist/ssr/Image'

interface CloudinaryImageThumbnailProps {
	photo?: string
	size?: number
	width?: number
	height?: number
	flexBasis?: string
	backgroundSize?: string
	pad?: boolean
	sx?: object
}

export function CloudinaryImageThumbnail({
	photo,
	size = 80,
	width = size,
	height = size,
	backgroundSize = 'cover',
	flexBasis = `${size}px`,
	pad = false,
	sx,
}: CloudinaryImageThumbnailProps) {
	const commonProps = getCommonProps(width, height, flexBasis)

	return photo ? (
		<Box
			sx={{
				...commonProps,
				backgroundImage: `url(${cloudinary.resizeImage(photo, width * 2, height * 2, pad)})`,
				backgroundPosition: 'center',
				backgroundSize,
				backgroundRepeat: 'no-repeat',
				overflow: 'hidden',
				...(pad && {
					backgroundSize: 'contain',
					aspectRatio: '1 / 1',
				}),
				...sx,
			}}
		/>
	) : (
		<Box
			sx={{
				...commonProps,
				bgcolor: 'var(--mui-palette-background-level2)',
				...sx,
			}}
		>
			<ImageIcon fontSize="var(--icon-fontSize-lg)" />
		</Box>
	)
}

const getCommonProps = (width: number, height: number, flexBasis: string) => ({
	justifyContent: 'center',
	borderRadius: 1,
	display: 'flex',
	alignItems: 'center',
	height: `${height}px`,
	width: `${width}px`,
	flexShrink: 0,
	flexBasis,
})
